import Competitor from 'components/presentation/Competitor';
import Label from "components/general/Label"
import Noc from 'components/presentation/Noc';
import { Table } from "react-bootstrap";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const Referees = ({ data, config, homeAway, showHeader }) => {
  const { mirs_rsc } = useUrlFriendlyToParameters()

  const avoidDuplicates = config?.avoidDuplicates === undefined ? false : config.avoidDuplicates;
  let hideNoc = config?.hideNoc === undefined ? false : config.hideNoc;
  const nationality = config?.nationality === undefined ? false : config.nationality;
  showHeader = showHeader === undefined ? false : showHeader
  if (Array.isArray(config?.filter)) {
    data = data?.filter(i => config.filter.includes(i?.function?.functionCode))
  }
  const id = homeAway === undefined ? `table-referees-${mirs_rsc}` : `table-referees-${mirs_rsc}-${homeAway}`

  return (
    <>
      {data
        ?
        <Table bordered className="table-referees" id={id}>
          {config?.header && <caption><Label data={config?.header} /></caption>}

          {showHeader && <thead><tr><th><Label data='HeaderFunction' /></th><th><Label data='HeaderName' /></th></tr></thead>}
          <tbody>
            {
              data?.map((item, index, self) => {
                let functionDescription = `${item.function?.description}:`;

                if (avoidDuplicates && index > 0) {
                  functionDescription = (self[index - 1].function?.functionCode === item.function?.functionCode) ? '' : `${item.function?.description}:`
                }

                let person
                if (config?.source === 'coach') {
                  person = item?.coach
                } else {
                  person = item?.official
                }

                const showNationality = nationality && person?.organisation?.code !== person?.nationality?.code
                hideNoc = hideNoc || (Array.isArray(config?.filterNoc) && config?.filterNoc?.includes(item?.function?.functionCode));
                let noc                
                if ( hideNoc && !showNationality) {
                  noc =<></>
                } else if (showNationality) {
                  noc = <Noc {...person?.nationality} />
                } else {
                  noc = <Noc {...person?.organisation} />
                }

                return (
                  <tr role="row" key={`referee-row-${index}`}>
                    <th className="col-3 fw-bold">
                      {item?.function?.description !== undefined ? functionDescription : 'Umpire'}
                    </th>
                    <td className="col-9">
                      <div className='d-flex justify-content-start'>

                        {noc}

                        <Competitor hidePicture={true} hideNoc={true} {...person} />

                      </div>
                    </td>
                  </tr>
                )
              }
              )
            }
          </tbody>
        </Table>
        : ''
      }
    </>
  )

}

export default Referees;
